import TransferDetails from "./transferDetails.container"

export default TransferDetails
